// src/redux/workflows/applications/slice.ts
import { createSlice } from '@reduxjs/toolkit';
import { ApplicationsState } from './types';
import { fetchApplications } from './thunk';

const initialState: ApplicationsState = {
  data: [],
  count: 0,
  next: null,
  previous: null,
  loading: false,
  error: null,
};

const applicationsSlice = createSlice({
  name: 'workflows/applications',
  initialState,
  reducers: {
    resetApplicationsState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchApplications.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchApplications.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.count = payload.count;
        state.next = payload.next;
        state.previous = payload.previous;
        state.data = payload.results;
      })
      .addCase(fetchApplications.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload ?? 'Failed to load applications';
      });
  },
});

export const { resetApplicationsState } = applicationsSlice.actions;
export default applicationsSlice.reducer;
